<!-- ACS Summary Cards Container -->
<div class="acs-summary" [class]="containerClass">
  <div class="acs-summary__grid" [ngClass]="gridClass">
    
    <!-- Dynamic Summary Cards -->
    <div
      *ngFor="let card of summaryCards"
      class="acs-summary__card"
      [class]="'acs-summary__card--' + (card.variant || 'default')"
      [attr.aria-label]="card.label + ': ' + formatCardValue(card)"
      role="article">

      <!-- Card Icon -->
      <div class="acs-summary__card-icon" *ngIf="card.icon">
        {{ card.icon }}
      </div>

      <!-- Card Content -->
      <div class="acs-summary__card-content">
        <div class="acs-summary__card-value" [attr.title]="formatCardValue(card)">
          {{ formatCardValue(card) }}
        </div>
        <div class="acs-summary__card-label">
          {{ card.label }}
        </div>
        <div class="acs-summary__card-sublabel" *ngIf="card.sublabel">
          {{ card.sublabel }}
        </div>
        
        <!-- Optional Progress Bar -->
        <div class="acs-summary__card-progress" *ngIf="card.progress !== undefined">
          <div class="acs-summary__progress-bar">
            <div 
              class="acs-summary__progress-fill" 
              [style.width.%]="card.progress"
              [class]="'acs-summary__progress-fill--' + (card.variant || 'default')">
            </div>
          </div>
          <div class="acs-summary__progress-text">
            {{ card.progress }}%
          </div>
        </div>
        
        <!-- Optional Change Indicator -->
        <div 
          class="acs-summary__card-change" 
          *ngIf="card.change !== undefined"
          [class.acs-summary__card-change--positive]="card.change > 0"
          [class.acs-summary__card-change--negative]="card.change < 0">
          <span class="acs-summary__change-icon">
            {{ card.change > 0 ? '↗' : card.change < 0 ? '↘' : '→' }}
          </span>
          <span class="acs-summary__change-value">
            {{ Math.abs(card.change) }}{{ card.changeUnit || '%' }}
          </span>
        </div>
      </div>
      
      <!-- Optional Action Button -->
      <button 
        *ngIf="card.action" 
        class="acs-summary__card-action"
        (click)="onCardAction(card)"
        [attr.aria-label]="card.action.label">
        {{ card.action.icon || '→' }}
      </button>
    </div>
    
  </div>
</div>